import React from 'react'

export default function Assets(props) {
  return (
    <div className='d-flex'>
      <h1 className={`text-${props.mode==='light'?'dark':'light'}`}>Coming Soon..</h1>
    </div>
  )
}
